module.exports = __webpack_public_path__ + "img/459-cc306d.png";